import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import colorConfigs from "../../../configs/colorConfigs";
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import Modal from "@mui/material/Modal";
import CloseIcon from '@mui/icons-material/Close';
import MultiStepper from "../../../components/MultiStep/multiStepVertical";
import CustomerDetailsForm from "./UserDetailForm/UserDetailForm";
import ContactDetailsForm from "./ContactDetailForm/contactDetailForm";
import ReviewCustomerData from "./ReviewCustomerData";
import TranslationGetHOC from "../../../components/layout/TranslationGetHOC";
import LoaderScreen from "../../../components/layout/LoaderScreen";
import AppPermissionHOC from "../../../components/layout/AppPermissionHOC";
import { AppAPiUrl, appModelPermission, appModelType, AppRoutesPath } from "../../../configs/appData";
import AxiosMain from "../../../components/layout/AxiosMain";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { setAppOrg } from "../../../redux/features/appStateSlice";
import { setorganizationState } from "../../../redux/features/organizationStateSlice";
import MaterialReactDataTable from '../../../components/layout/MaterialReactDataTable';

const customerModalstyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "75%",
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: "calc(100% - 80px)",
    overflow: "auto",
    borderRadius: "21px",
    boxsize: "content-box",
};

const formData = [
    { title: "", state: "completed", step: 1 },
    { title: "DeliveryAddress", state: "current", step: 2 },
    { title: "InvoiceAddress", state: "current", step: 3 },
    { title: "CommercialContact", state: "incomplete", step: 4 },
    { title: "TechnicalContact", state: "incomplete", step: 5 },
    { title: "ReviewDetails", state: "incomplete", step:6 },
]

interface Organization {
    id: number;
    name: string;
    agent: number | null;
    reseller: number;
    information: string;
    is_sale_agent: boolean;
    is_sale_agent_organization: boolean;
    is_sale_reseller: boolean;
    is_sale_reseller_customer: boolean;
    goodsign_org_identifier: number | null;
    odoo_org_identifier: number;
    is_primary: boolean;
}

const NewCustomerPage = (props: any) => {

    const { translateDataft } = props;
    const [currentStep, setCurrentStep] = useState<number>(1)
    const [formDataObj,setFormDataObj] = useState<any>({})
    const [countries, setCountries] = useState<any>([])

    const [iComponetTranslate, setICTranslation] = useState([]);
    const [customerModalOpen, setCustomerModalOpen] = useState(false)
    const { appCountry } = useSelector((state: RootState) => state.appState);

    const [submitting, setSubmitting] = useState(false);

    const navigate = useNavigate()
    const dispatch = useDispatch()

    
    const t = (name: string) => {
        const ifExist: any = iComponetTranslate.filter((item: any) => item.label === name);
        if (ifExist.length > 0) {
            return ifExist[0].value ? ifExist[0].value : `No translate found (${ifExist[0].label})`;
        }
        return `No key found (${name})`;
    }

    useEffect(() => {
        
        const newCode = appCountry.toLocaleLowerCase();
        if (translateDataft && translateDataft.hasOwnProperty(`${newCode}`)) {
            setICTranslation(translateDataft[`${newCode}`]);
        }
        else {
            setICTranslation([]);
        }
    }, [translateDataft, appCountry]);

    useEffect(() => {
        fetch_countries_list()
    },[])

    const handleStepIncrement = (data: any) => {
        let review = data.review;
        setFormDataObj({...formDataObj,...data})
        if(review){
            setCurrentStep(6);
        }
        else{
            setCurrentStep(prev => prev + 1);
        }
    }

    const handleStepDecrement = () => {
        setCurrentStep(prev => prev - 1);
    }

    const handleCloseModal = ()=>{
        setCustomerModalOpen(false)
        setFormDataObj({})
        setCurrentStep(1)
    }

    const handleSubmitForm  =() =>{
        setSubmitting(true);
        AxiosMain.post(AppAPiUrl.AddCustomer, {...formDataObj}).then((res) => {
            if ( res.status === 201 ) { 
                Swal.fire({
                  text: "Customer Created Successfully, Do you want to create Sales order for just created customer?",
                  icon: 'success',
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  showCancelButton: true,
                  confirmButtonColor: '#103256',
                  cancelButtonColor: '#d33',
                }).then((result) => {
                    console.log(result);
                    handleOrgUpdate(res.data.instance, result.isConfirmed);
                })
            }
        }).catch((e) => {
            console.error(e);
            Swal.fire({
                title: "Error",
                text: `Unable to create customer, Please try again later. \n Error Details: ${e.response.data.error || e.message}`,
                icon: "error"
            })
        }).finally(()=>{
            setSubmitting(false);
        })
    }

    const fetch_countries_list = () =>{
        AxiosMain.get(AppAPiUrl.FetchCountries)
        .then((response) => {
            if(response.status === 200){
                setCountries(response.data)
            }
        })
    }

    const fetch_states_of_country = async(id:any) =>{
        const response = await AxiosMain.get(AppAPiUrl.FetchStates.replace('<id>',id))
        if(response.status===200){
            return response.data
        }
    }

    const update_state_form = async () => {
        setCurrentStep(6);
    }

    const handleOrgUpdate = (instance:any, result:boolean) => {
        AxiosMain(AppAPiUrl.AllOrgFetch).then((response)=>{
            const data:Organization[] = response.data;
            const org_data = data.sort((a: any, b: any) =>
                a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
            );
            dispatch(setorganizationState(org_data));
            if(result){
                dispatch(setAppOrg(instance));
                navigate(AppRoutesPath.AccountingSalesOrder, { state : { enableModal: true }});
            }
            handleCloseModal();
        }).catch((error)=>{
            Swal.fire({
                title: "Error",
                text: `Error Fetching Organization data, Error: ${error}`,
                icon: "error"
            }).then(()=>{
                handleCloseModal();
            })
        });
    }

    const customerRow = [
        {
          accessorFn: (row: any) => row.name,
          header: t("Customer"),
        },
      ]

    const handleCustomerSelect = (row: any) =>{
        dispatch(setAppOrg(row));
        navigate("");
    };

    const customerSorting = [
        {
          descSort: "-name",
          ascSort: "name",
          id: t("Customer"),
        },
      ];

    const customerSearching = [
        {
          match: "name",
          id: t("SalesOrderID"),
        }
      ];

    return (
        <>
            <Modal
                open={customerModalOpen}
                onClose={() => setCustomerModalOpen(false)}
                aria-labelledby="Modal-User-Add"
                aria-describedby="Modal-User-Add"
            >
                <Box sx={customerModalstyle}>
                    <Box sx={{
                        textAlign: "right",
                        position: "absolute",
                        top: "12px",
                        right: "25px",
                    }}> <CloseIcon onClick={handleCloseModal} sx={{
                        color: "#CCCCCC",
                        width: "38px",
                        height: "38px",
                        cursor: "pointer"
                    }} /></Box>
                    <Box display={"flex"} flexDirection={"row"} padding={'20px'}>
                    {currentStep < 6 && <Box sx={{ flex: 1, paddingTop: "20px" }}>
                            <MultiStepper currentStep={currentStep} iComponetTranslate={iComponetTranslate} />
                        </Box>}
                        <Box sx={{ flex: 1, paddingTop: "20px", flexDirection: "column", justifyContent: "space-between" }}>
                            {currentStep === 1 && <CustomerDetailsForm
                                title={formData[0].title}
                                currentStep={currentStep}
                                defaultData = {formDataObj?.customer}
                                handleBack={handleStepDecrement}
                                handleNext={(values: any)=>handleStepIncrement(values)}
                                iComponetTranslate={iComponetTranslate}
                                countries={countries}
                                load_states={fetch_states_of_country}
                                update_state={update_state_form}
                                customerData={{}}
                            />}
                            {currentStep === 2 && <CustomerDetailsForm
                                title={formData[1].title}
                                currentStep={currentStep}
                                defaultData = {formDataObj?.deliveryAddress}
                                handleBack={handleStepDecrement}
                                handleNext={(values: any)=>handleStepIncrement(values)}
                                customerData = {formDataObj?.customer}
                                iComponetTranslate={iComponetTranslate}
                                countries={countries}
                                load_states={fetch_states_of_country}
                                update_state={update_state_form}
                            />}
                            {currentStep === 3 && <CustomerDetailsForm
                                title={formData[2].title}
                                currentStep={currentStep}
                                defaultData = {formDataObj?.invoiceAddress}
                                handleBack={handleStepDecrement}
                                handleNext={(values: any)=>handleStepIncrement(values)}
                                customerData = {formDataObj?.customer}
                                iComponetTranslate={iComponetTranslate}
                                countries={countries}
                                load_states={fetch_states_of_country}
                                update_state={update_state_form}
                            />}
                            {currentStep === 4 && <ContactDetailsForm
                                title={formData[3].title}
                                currentStep={currentStep}
                                defaultData = {formDataObj?.commercialContact}
                                handleBack={handleStepDecrement}
                                handleNext={(values: any)=>handleStepIncrement(values)}
                                iComponetTranslate={iComponetTranslate}
                                update_state={update_state_form}
                                />}
                            {currentStep === 5 && <ContactDetailsForm
                                title={formData[4].title}
                                currentStep={currentStep}
                                defaultData = {formDataObj?.technicalContact}
                                handleBack={handleStepDecrement}
                                handleNext={(values: any)=>handleStepIncrement(values)}
                                iComponetTranslate={iComponetTranslate}
                                />}
                            { currentStep === 6 && <ReviewCustomerData 
                                title={formData[5].title}
                                handleNext={handleSubmitForm}
                                handleBack={handleStepDecrement}
                                submitting = {submitting}
                                defaultData = {formDataObj}
                                countries={countries}
                                iComponetTranslate={iComponetTranslate}
                            />}
                        </Box>
                    </Box>
                </Box>
            </Modal>
            <Box sx={{
                padding: "40px",
                background: "#fff",
                height: "100vh"
            }}>
                <div className="text-right">
                    <Button
                        onClick={() => setCustomerModalOpen(true)}
                        variant="contained"
                        endIcon={<AddIcon />}
                        className="cm-btn-style"
                        sx={{
                            my: 1,
                            color: colorConfigs.btnStyle.color,
                            background: colorConfigs.btnColor.bgColorGreen,
                            "&: hover": {
                                color: colorConfigs.btnColor.colorGreen,
                                background: colorConfigs.btnColor.hoverbgWhite,
                            },
                        }}
                    >
                        {t("AddCustomer")}
                    </Button>
                </div>
                <MaterialReactDataTable
                    useFor={"Customers List"}
                    apiLink={AppAPiUrl.FetchCustomerList}
                    tRow={customerRow}
                    clickFunc={handleCustomerSelect}
                    sortingData={customerSorting}
                    searchData={customerSearching}
                />
            </Box>
        </>
    )

};
function NewCustomerPageComponentReady({ isAllow }: any) {
    const dependency = { require: ['Sidebar'] };
    const MainComponent = TranslationGetHOC(NewCustomerPage, "newcustomer", isAllow, {}, dependency);
    return isAllow ? <MainComponent /> : (<LoaderScreen msg="Loading ..." />)
  }
  export default AppPermissionHOC(NewCustomerPageComponentReady, appModelPermission.SETERAUSER, appModelType.READ);